import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Token = ({
  size,
  type,
  theme,
  className,
  dataTestId = "token-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      d="M5.333 8.667a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-.666 2a.667.667 0 1 1 1.333 0 .667.667 0 0 1-1.333 0Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.471.862a.667.667 0 0 0-.942 0L9.667 2.724l-.529-.529a.667.667 0 0 0-.933-.01L2.422 7.738a4.13 4.13 0 1 0 5.84 5.84l5.552-5.782a.667.667 0 0 0-.01-.933l-.528-.529 1.862-1.862a.667.667 0 0 0 0-.942L12.471.862Zm-.138 4.528L10.61 3.667 12 2.277 13.724 4l-1.39 1.39ZM3.345 8.7l5.312-5.1L12.4 7.343l-5.1 5.311A2.797 2.797 0 1 1 3.347 8.7Z"
      clipRule="evenodd"
    />
  </SVGIcon>
);
